module.exports = __webpack_public_path__ + "img/10.5cd35b0a.jpg";